/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useAncestorPath } from '@squiz/dxp-console-support';
import { Breadcrumbs, BreadcrumbsProps } from '@squiz/sds';
import { DxpScreen } from 'apps/console-core/src/Components/DxpScreen/DxpScreen';
import { useCapabilityBreadcrumbs } from 'apps/console-core/src/Hooks/UseCapabilityBreadcrumbs/UseCapabilityBreadcrumbs';
import { getSlug } from 'apps/console-core/src/Utilities/GetSlug/GetSlug';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CONFIGURATION_STRINGS } from '../../../../Constants/Strings.constants';
import { RouteList } from '../../elements/RouteList/RouteList';

/**
 * The manage routing screen.
 */
export const ManageRouting = (): JSX.Element => {
  const { t } = useTranslation();
  const parentPath = useAncestorPath(false, 1);

  // Labels
  const labels = useMemo(() => {
    return {
      apiError: t(CONFIGURATION_STRINGS.apiError) as string,
      staticSites: t(CONFIGURATION_STRINGS.staticSites) as string,
    };
  }, [t]);

  // Initialise capability breadcrumbs
  const capabilityBreadcrumbs = useCapabilityBreadcrumbs();

  const encodedUrl = getSlug();
  const siteUrl = atob(encodedUrl);

  // Breadcrumbs
  capabilityBreadcrumbs.push({ name: labels.staticSites, url: parentPath });
  const breadcrumbProps: BreadcrumbsProps = {
    currentPageName: siteUrl,
    links: capabilityBreadcrumbs,
  };
  const breadcrumbs = <Breadcrumbs {...breadcrumbProps} data-id="manage-routing-breadcrumbs" />;

  const screenContent = (
    <>
      <RouteList siteUrl={siteUrl} />
    </>
  );

  return (
    <DxpScreen breadcrumbs={breadcrumbs} classes="manage-routing__screen" heading={siteUrl} showSeparator>
      {screenContent}
    </DxpScreen>
  );
};
